var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Arrow","transform":"translate(15.000000, 15.000000) rotate(-180.000000) translate(-15.000000, -15.000000) ","fillRule":"nonzero","key":3},[React.createElement("circle",{"id":"Oval-3","fill":"#50E3C2","cx":"15","cy":"15","r":"15","key":0}),React.createElement("polygon",{"id":"Triangle","fill":"#FFFFFF","transform":"translate(16.754506, 15.000000) rotate(-90.000000) translate(-16.754506, -15.000000) ","points":"16.754506 19.2454932 10.373511 10.754506 23.135501 10.754506","key":1})])]);
}

ArrowLeft.defaultProps = {"width":"30px","height":"30px","viewBox":"0 0 30 30","version":"1.1"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
